import type { IconSvgObject } from './types';

const EqualSignIcon: IconSvgObject = [
  ["path", { d: "M4 8H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 16H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EqualSignIcon;
